import type { NoticeHistoryItem } from './types';

export const getNoticeStatusLabel = (notice: NoticeHistoryItem): string =>
  notice.acknowledged ? 'Visualizado' : 'Não visualizado';

export const getNoticeStatusClass = (notice: NoticeHistoryItem): string =>
  notice.acknowledged ? 'bg-green-20 text-gray-07' : 'bg-badge-orange-30 text-badge-orange';
